import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-950 px-4 py-10 sm:px-6" data-id="element-166" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-167" data-mp="206rj9imgluta">
        <p className="font-display text-xl uppercase text-white" data-id="element-168" data-mp="2f5d5xcuvnaq5">TRT Decision Deck™</p>
        <p className="mt-2 text-xs text-sky-100/50" data-id="element-169" data-mp="2a606ztqqed77">
          © 2026 · Dr. Karito – TRT Decision Deck™ · All Rights Reserved.
        </p>

        <div className="mt-6 rounded-xl border border-white/10 bg-navy-900 p-5 text-left" data-id="element-170" data-mp="1mgxsgure90gx">
          <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.15em] text-sky-400" data-id="element-171" data-mp="1hi4bgscwerc0">
            Important educational disclaimer
          </p>
          <p className="text-xs leading-relaxed text-sky-100/60" data-id="element-172" data-mp="1w7sbzrd99lyo">
            The TRT Decision Deck™ is an educational resource intended for qualified healthcare
            professionals. It does not replace professional clinical judgment, current clinical
            practice guidelines, official prescribing information, applicable regulations, or
            appropriate specialist consultation.
          </p>
          <p className="mt-3 text-xs leading-relaxed text-sky-100/60" data-id="element-173" data-mp="1ijfirsvm6cre">
            Clinical decisions should always be individualized according to the patient’s history,
            examination, laboratory findings, risk factors, applicable regulations, and the most
            current available evidence.
          </p>
        </div>

        <div className="h-16" aria-hidden="true" data-id="element-174" data-mp="vkjaiy0kjp71" />
      </div>
    </footer>;
}